import { type ReactNode } from "react";

type SummaryFieldGroupProps = {
	children: ReactNode;
};

export const SummaryFieldGroup = ({ children }: SummaryFieldGroupProps) => {
	return <div className="flex flex-col space-y-[5px]">{children}</div>;
};
